
export interface BusinessLandingSettings {
  id?: string;
  businessId: string;
  // Color scheme
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  backgroundColor: string;
  textColor: string;
  // Content
  heroTitle: string;
  heroSubtitle: string;
  featureTitle: string;
  features: BusinessFeature[];
  ctaTitle: string;
  ctaText: string;
  ctaButtonText: string;
  // Footer
  footerText: string;
  // SEO
  metaTitle: string;
  metaDescription: string;
}

export interface BusinessFeature {
  id: string;
  title: string;
  description: string;
  iconName?: string;
}

export const defaultLandingSettings: BusinessLandingSettings = {
  businessId: "",
  primaryColor: "#1A365D", // primary-blue
  secondaryColor: "#2B6CB0", // primary-lightBlue
  accentColor: "#4299E1",
  backgroundColor: "#EDF2F7",
  textColor: "#1A202C",
  heroTitle: "Join Our Referral Program",
  heroSubtitle: "Refer friends and earn rewards with our easy-to-use referral system",
  featureTitle: "Why Join Our Referral Program?",
  features: [
    {
      id: "1",
      title: "Easy Sharing",
      description: "Share your unique referral link via email, social media, or messaging apps.",
      iconName: "share"
    },
    {
      id: "2",
      title: "Track Your Referrals",
      description: "Monitor the status of your referrals in real-time through your dashboard.",
      iconName: "activity"
    },
    {
      id: "3",
      title: "Earn Rewards",
      description: "Get paid for successful referrals with our competitive reward structure.",
      iconName: "gift"
    }
  ],
  ctaTitle: "Ready to Start Earning?",
  ctaText: "Create your free referral account today and start sharing.",
  ctaButtonText: "Sign Up Now",
  footerText: "© " + new Date().getFullYear() + " All rights reserved.",
  metaTitle: "Join Our Referral Program - Start Earning Today",
  metaDescription: "Sign up for our referral program and earn rewards for successful referrals. Easy to join, simple to use."
};
